import VideoPlyr from "../fragments/VideoPlyr";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Video({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const mediaRevealRef = useReveal({ once: true });
    const mediaAltRevealRef = useReveal({ once: true });

    let colClass = 'l-grid__col ';
    if (block.alignment === 'left') {
        colClass += 'l-grid__col--m-7-12 l-grid__col--l-8-12'
    } else if (block.alignment === 'right') {
        colClass += 'l-grid__col--m-7-12 l-grid__col--l-8-12 l-grid__col--m-push-5-12 l-grid__col--l-push-4-12'
    }
    colClass += ' c-transition-in';

    return (
        <div className={`c-page__block c-page__block--media`}>
            <div className={`l-grid`}>
                <div className={colClass} ref={mediaRevealRef}>
                    <VideoPlyr
                        posterSrc={block.cover_image}
                        videoSrc={block.video}
                    />
                </div>
            </div>
        </div>
    );
   
}